import * as React from 'react';
import OrgCalendar from 'components/calendar/organization-calendar';
import { RouteComponentProps } from 'react-router';
import { AuthContext } from 'auth';

export interface Props extends RouteComponentProps<any> {}

const CalendarPage = ({
  match: {
    params: { orgId },
  },
}: Props) => {
  const { user } = React.useContext(AuthContext);

  return (
    <div id="calendar-page" className="container hub-full-width">
      <div className="u-xs-padXl">
        <OrgCalendar organizationId={orgId} />
      </div>
    </div>
  );
};

export default CalendarPage;
